import { useNavigate } from 'react-router-dom'
import { Alert, Button, Typography } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import FeatureThemeProvider from '@/components/FeatureThemeProvider'
import { useAuthSession } from '@/lib/session'
import McpManageGate from '../components/McpManageGate'
import FirmProfilePanel from './FirmProfilePanel'

export default function FirmProfilePage() {
  const navigate = useNavigate()
  const session = useAuthSession()
  const clientId = session?.currentClientId ?? ''
  const clientName = session?.currentClientName || 'this client'

  return (
    <FeatureThemeProvider featureKey="pracIntel" withAntd className="px-6 py-6 md:px-8">
      <div className="relative mx-auto w-full max-w-6xl">
        <div className="pt-1 pb-4">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <Typography.Title level={3} className="!mb-1">
                Firm profile
              </Typography.Title>
              <Typography.Text type="secondary">Current client: {clientName}</Typography.Text>
            </div>
            <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/reports/dashboard-builder')}>
              Back to PracIntel
            </Button>
          </div>
        </div>
        {clientId ? (
          <McpManageGate clientId={clientId} deniedMessage={`Only ${clientName}’s admins can see the firm profile.`}>
            <FirmProfilePanel key={clientId} clientId={clientId} clientName={clientName} />
          </McpManageGate>
        ) : (
          <Alert type="info" showIcon message="Choose a client to see its firm profile." />
        )}
      </div>
    </FeatureThemeProvider>
  )
}
